import React from "react";
import Container from "react-bootstrap/Container";

const Footer = (props) => {
  const bgStyle = { backgroundColor: "#f5f5f5" };

  return (
    <footer style={bgStyle} className="mt-auto py-5 text-center ">
      <Container>
        {props.children}
        <i className="fas fa-code" /> con <i className="fas fa-heart" /> por{" "}
        <a
          className="badge badge-dark"
          rel="noopener"
          href="https://github.com/RoqueRojo"
          aria-label="My GitHub"
        >
          Roque Rojo Bacete
        </a>{" "}
        usando <i className="fab fa-react" />
        <p>
          <small className="text-muted">
            Mantenido gracias a GitHub-Pages
          </small>
        </p>
      </Container>
    </footer>
  );
};

export default Footer;
